/**
 * @enum
 */
export const Constants = {
  MAX_TITLE_LENGTH: 50,
  MAX_TEXT_LENGTH: 400,
  MAX_TEXT_MULTILAB: 50,
};
